export { actions } from './actions'
export { reducer } from './reducer'



// WEBPACK FOOTER //
// ./src/shared/redux/schools/index.js